module.exports = __webpack_public_path__ + "img/warning.a7536e5e.png";